export default __webpack_public_path__ + "static/media/X.b2d98efb.svg";